import React from 'react';
import moment from 'moment';

import events from 'lib/events.js';

import ReportApi from 'api/report.jsx';

import ConfirmationModal from './confirmationModal.jsx';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class SeasonsUsageSummary extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    disableDownload: false,
  };

  getDownloadButton = () => {
    const {data} = this.props;
    let {formatMessage} = this.props.intl;
    let buttontext = formatMessage({id: 'reports.season.download'});
    let timeEstimate = this.calculateTime(data);
    let timeUnits = formatMessage({id: 'reports.season.time.mins'});

    if (timeEstimate > 0) {
      if (timeEstimate > 60) {
        timeUnits = formatMessage({id: 'reports.season.time.hrs'});
        timeEstimate = (timeEstimate / 60).toFixed(1);
      }
      buttontext = formatMessage({id: 'reports.season.download'}) + ' (' + timeEstimate + timeUnits + ')';
    }

    let output = '';

    output =
      <button className='btn btn-primary pull-right'
        disabled={this.state.disableDownload || this.checkDownloadAllEnable()}
        onClick={this.confirmDownload}>{buttontext}
      </button>
    ;
    return output;
  };

  getSeasonUsageReportHistory = () => {
    const {history, branches} = this.props;
    let {formatMessage} = this.props.intl;
    let {truBlueActive} = this.props;

    if (history !== null) {
      const link = history.Link.substring(history.Link.indexOf(':') + 1, history.Link.length);
      let branchName = formatMessage({id: 'general.all.stores'});
      const [truBlueStatus, active] = history.Data.slice(4);

      const dateRun = moment(history.Created).format('MM-DD-YYYY');
      let status = '';

      if (history.Status === -100) {
        status = <span style={{color: 'red'}}><FormattedMessage id="general.failed" /></span>;
      } else if (history.Status >= 0 && history.Status < 100) {
        status = <span style={{color: 'orange'}}>{history.Status}%</span>;
      } else if (history.Status === 100) {
        status = <span style={{color: 'green'}}>{history.Status}%</span>;
      }


      if (history.Data[3]) {
        branchName = branches.find(b => b.id === parseInt(history.Data[4])) || branchName;
      }

      return <table className='table'>
        <thead>
          <tr>
            <th><FormattedMessage id="reports.season.date.run" /></th>
            <th><FormattedMessage id="reports.season.store.filter" /></th>
            {truBlueActive ?
              <th><FormattedMessage id="reports.season.trublue.filter" /></th> :
            null}
            <th><FormattedMessage id="general.active.customers" /></th>
            <th><FormattedMessage id="general.progress" /></th>
            <th><FormattedMessage id="general.download" /></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{dateRun}</td>
            <td>{branchName}</td>
            {truBlueActive ?
              <td>{truBlueStatus !== '' ?  truBlueStatus : formatMessage({id: 'general.all'})}</td> :
            null}
            <td>{active}</td>
            <td>{status}</td>
            <td>
              {link !== '' ?
                <a target='_blank' href={link}><FormattedMessage id="reports.season.download.report" /></a> :
                formatMessage({id: 'reports.season.no.link'})}
            </td>
          </tr>
        </tbody>
      </table>;
    }

    return formatMessage({id: 'general.no.records.found'});
  };

  calculateTime = (data) => {
    let pools = 0;
    let timeEstimate = 0;

    if (data) {
      pools = data.TotalPools + data.SwimSpas + data.Spas;
      if (pools > 0) {
        timeEstimate = (0.025 * pools).toFixed(0);
        return timeEstimate;
      }
    }
    return timeEstimate;
  };

  checkDownloadAllEnable = () => {
    const {history} = this.props;

    return !(history === null || history.Completed !== null);
  };

  confirmDownload = event => {
    event.stopPropagation();
    const {data} = this.props;
    const {formatMessage} = this.props.intl;

    let timeEstimate = this.calculateTime(data);
    let timeUnits = timeEstimate > 60 ? formatMessage({id: 'reports.season.time.hours'}) : formatMessage({id: 'reports.season.time.minutes'});
    let timetext = ` ${formatMessage({id: 'reports.season.estimate.update'})}`;

    if (timeEstimate > 0) {
      timeEstimate = (timeEstimate > 60 ? timeEstimate / 60 : timeEstimate).toFixed(1);
      timetext = ` ${formatMessage({id: 'reports.season.estimate.update'}, {estimate: timeEstimate, units: timeUnits})}`;
    }

    this.setState({
      confirmationModalContent: <div>
        <h2><FormattedMessage id="general.confirmation" /></h2>
        <p className='info-modal-description'>
          <span className='modal-warning'>
            <i className='bl bl-attention' />
            <FormattedMessage id="reports.season.generate.season" /> {timetext}
          </span>
          <br />
          <br />
          <FormattedMessage id="reports.season.click.confirm" />:<br />
          &ensp;&ensp;- <FormattedMessage id="reports.season.overwrite.season" /><br />
          &ensp;&ensp;- <FormattedMessage id="reports.season.receive.notification" /><br />
          &ensp;&ensp;- <FormattedMessage id="reports.season.run.task" /><br />
        </p>
      </div>,
    });
    events.publish('season-usage-confirmation-modal');
  };

  confirmModalAction = () => {
    let filters = this.props.filters;
    let {formatMessage} = this.props.intl;

    this.setState({
      disableDownload: true,
      loaded: false,
    });
    ReportApi.getSeasonsUsageReportPDFGeneration(
      filters.dateFrom,
      filters.dateTo,
      filters.branch ? filters.branch : 0,
      filters.truBlueStatus,
    ).then(() => {
      events.publish('success.user', {
        message: formatMessage({id: 'reports.season.submitted'}),
        key: 'Season Usage Report Submitted',
      });
    }).catch((e) => {
      console.log(e);
      events.publish('error.user', {
        message: formatMessage({id: 'reports.season.not.submitted'}),
        key: 'Season Usage Report Not Submitted',
      });
      this.setState({loaded: true});
    });
  };

  render() {
    return (
      <div className='seasons-usage-report-summary'>
        {this.props.showNoDataMessage ?
          <div><label className='report-no-data'><FormattedMessage id="reports.season.no.usage" /></label></div> :
            null}
        <div className='col-sm-12 button-group'>
          {this.getDownloadButton()}
        </div>
        <div className='col-sm-12'>
          <h2><FormattedMessage id="general.latest.downloaded.report" /></h2>
          {this.props.history ?
            this.getSeasonUsageReportHistory() :
            <FormattedMessage id="general.no.records.found" />}
        </div>
        <ConfirmationModal onConfirm={this.confirmModalAction}>{this.state.confirmationModalContent}</ConfirmationModal>
      </div>
    );
  }
}

export default injectIntl(SeasonsUsageSummary);
